var _circle, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagTunisie(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10290_49456)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 15,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10290_49456",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 30,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 34C27.2843 34 34 27.2843 34 19C34 10.7157 27.2843 4 19 4C10.7157 4 4 10.7157 4 19C4 27.2843 10.7157 34 19 34Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10290_49456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0828 16.7452L21.347 17.6538L19.6389 15.3301L19.6538 18.2099L16.918 19.1186L19.6637 19.9924L19.6786 22.8772L21.3619 20.5337L24.1076 21.4125L22.3996 19.0888L24.0828 16.7452Z",
    fill: "url(#paint0_linear_10290_49456)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.49609 4V33.995H41.4989V4H-3.49609ZM19.0014 27.7984C14.1405 27.7984 10.203 23.861 10.203 19C10.203 14.139 14.1405 10.2016 19.0014 10.2016C23.8624 10.2016 27.7998 14.139 27.7998 19C27.7998 23.861 23.8624 27.7984 19.0014 27.7984Z",
    fill: "url(#paint1_linear_10290_49456)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5921 19.1049C15.5921 16.1059 18.0202 13.6779 21.0192 13.6779C22.0917 13.6779 23.0897 13.9907 23.9288 14.527C22.7123 13.236 20.9844 12.4316 19.0728 12.4316C15.3836 12.4267 12.3945 15.4158 12.3945 19.1049C12.3945 22.7941 15.3836 25.7832 19.0728 25.7832C20.9894 25.7832 22.7123 24.9788 23.9288 23.6879C23.0897 24.2241 22.0917 24.5369 21.0192 24.5369C18.0251 24.5319 15.5921 22.099 15.5921 19.1049Z",
    fill: "url(#paint2_linear_10290_49456)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0015 10.2012C14.1406 10.2012 10.2031 14.1386 10.2031 18.9996C10.2031 23.8606 14.1406 27.798 19.0015 27.798C23.8625 27.798 27.7999 23.8606 27.7999 18.9996C27.7999 14.1386 23.8625 10.2012 19.0015 10.2012ZM19.0711 25.7821C15.3819 25.7821 12.3928 22.7881 12.3928 19.1039C12.3928 15.4147 15.3819 12.4256 19.0711 12.4256C20.9876 12.4256 22.7106 13.23 23.9271 14.5209C23.0879 13.9847 22.0899 13.6719 21.0174 13.6719C18.0184 13.6719 15.5904 16.0999 15.5904 19.0989C15.5904 22.0979 18.0184 24.5259 21.0174 24.5259C22.0899 24.5259 23.0879 24.2131 23.9271 23.6768C22.7106 24.9728 20.9876 25.7821 19.0711 25.7821ZM21.36 20.5338L19.6768 22.8725L19.6619 19.9877L16.9161 19.1088L19.652 18.2051L19.6371 15.3203L21.3451 17.6441L24.081 16.7404L22.3978 19.079L24.1058 21.4028L21.36 20.5338Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10290_49456",
    x: 0,
    y: 0,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.341176 0 0 0 0 0.329412 0 0 0 0 0.898039 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10290_49456"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10290_49456",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10290_49456",
    x1: -3.49414,
    y1: 19.1025,
    x2: 41.5009,
    y2: 19.1025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF1400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF1400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10290_49456",
    x1: -3.49609,
    y1: 18.9986,
    x2: 41.499,
    y2: 18.9986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF1400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF1400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10290_49456",
    x1: -3.49424,
    y1: 19.1037,
    x2: 41.5008,
    y2: 19.1037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF1400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF1400"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagTunisie);
export default __webpack_public_path__ + "static/media/flagTunisie.191976f7c7aa075fe20a27847f0fcca7.svg";
export { ForwardRef as ReactComponent };